/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';
import { isDesktop } from 'react-device-detect';
import { verifySign } from '@api';
import CertModal from './CertModal';
const ApplyReturnModal = ({ mtRate }) => {
    // 簽驗
    const [errMsg, setErrMsg] = useState('');
    const [certificateNumber, setCertificateNumber] = useState('');
    // const veriObj = {};
    let tempObj = {};
    const [veriObj, setVeriObj] = useState({});
    function sign_callback(obj) {
        // veriObj.signature = obj.signed;
        // veriObj.serial = obj.casno;
        // veriObj.data = idno + ',return';
        tempObj = {};
        tempObj.signature = obj.signed;
        tempObj.serial = obj.casno;
        tempObj.data = idno.trim() + ',return';
        setVeriObj(tempObj);
        setCertificateNumber(obj.casno);
    }
    // const sign_callback = obj => {
    //     // 設false才可再次執行
    //     setmtksign(false);
    //     // 開始驗章流程
    //     veriObj.signature = obj.signed;
    //     veriObj.serial = obj.casno;
    //     verifySignFunc(veriObj).then(() => {
    //         setIsVerifyComplete(true);
    //     });
    // };

    async function verifySignFunc(veriObj) {
        const res = await verifySign(veriObj);
        if (res.data.code === '0') {
            setCertificateNumber(veriObj.serial);
        } else {
            // todo modal res.data.message
        }
        return res;
    }
    // 簽驗結束
    const {
        ReturnStore: {
            userCollateral,
            applyReturnModalVisible,
            closeApplyReturnModal,
            applyReturn,
            getReturnBusinessTime,
            applyDisabled,
            updateData,
        },
        AuthStore: { updateUserInfo, borrowingAmount, idno },
    } = useStore();
    useEffect(() => {
        if (applyReturnModalVisible) {
            if (!signWeb) {
                // 測試機關閉簽驗
                setCertificateNumber('test');
            } else {
                // 打開先簽章
                if (!isDesktop) {
                    const signObj = {
                        cb: sign_callback,
                    };
                    signObj.idno = idno.trim();
                    signObj.tosign = idno.trim() + ',return';
                    // veriObj.data = idno + ',return';
                    // P1
                    signObj.method = 'P7';
                    // eslint-disable-next-line no-undef
                    mtklib.sign(signObj);
                } else {
                    // 判斷web還是ap?
                    console.log(!!window.chrome.webview);
                    const capiobj = getCGCAPIATLADPTObj();
                    if (capiobj !== undefined) {
                        console.log('載入成功 !');
                        if (capiobj.NeedUpdateInstaller()) {
                            // 檢查是否有新版本要版更
                            const msg =
                                '已有新版[簽章ServiSign]元件，請重新下載及手動安裝元件後，再重新執行網頁!';
                            setErrMsg(msg);
                            updateData('certModalVisible', true);
                            closeApplyReturnModal();
                            return;
                        }
                    } else {
                        console.log('載入失敗 !');
                        setErrMsg('全景程式載入失敗');
                        updateData('certModalVisible', true);
                        closeApplyReturnModal();
                        return;
                    }
                    const iKeyUsage = 0;
                    const strCSP = '';
                    const iHashFlags = 0x04; // SHA256

                    const text = idno.trim() + ',return'; // 簽章原文
                    let SignDataPC = '';
                    const id1 = 'CN=TW' + idno.trim() + '1'; // 身分證號

                    const strSubject = id1 + '\nOU=PSCNET'; // 統一證券OU
                    const strIssuer = '';
                    const strPin = '';

                    const iFlags =
                        CGCAPI_FLAG_SELCERT_AUTO +
                        '|' +
                        CGCAPI_FLAG_SELCERT_CHECKVALID;

                    let min = 10000;

                    const t1 = new Date().getTime();

                    SignDataPC = capiobj.CAPISign(
                        text,
                        'MS950',
                        strSubject,
                        strIssuer,
                        strCSP,
                        '',
                        iFlags,
                        iHashFlags,
                        iKeyUsage
                    ); // strIssure, strCSP, iKeyUsage固定
                    const t2 = new Date().getTime();
                    if (t2 - t1 < min) min = t2 - t1;
                    const rtn = capiobj.GetErrorCode();

                    if (rtn !== 0) {
                        setErrMsg('簽章失敗!錯誤代碼:' + GetErrorMessage(rtn));
                        updateData('certModalVisible', true);
                        closeApplyReturnModal();
                    } else {
                        // 簽章成功取憑證序號
                        const subject = 'CN=TW' + idno.trim() + '1\nOU=PSCNET';
                        const flag =
                            CGCAPI_FLAG_SELCERT_AUTO +
                            '|' +
                            CGCAPI_FLAG_SELCERT_CHECKVALID;
                        const cert = capiobj.CAPI_XGetUserCertificate(
                            '',
                            subject,
                            flag,
                            0,
                            ''
                        ); // provider, keyusage, 第五個欄位為固定值
                        let rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            setErrMsg('取得使用者憑證失敗' + rtn);
                            updateData('certModalVisible', true);
                            closeApplyReturnModal();
                            return;
                        }
                        // 憑證取得序號
                        const serial = capiobj.CAPICertGetSerialNumber(cert, 0);
                        rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            setErrMsg(
                                '取得憑證序號失敗!錯誤代碼:' +
                                    GetErrorMessage(rtn)
                            );
                            updateData('certModalVisible', true);
                            closeApplyReturnModal();
                            return;
                        }
                        tempObj = {};
                        tempObj.signature = SignDataPC;
                        tempObj.serial = serial;
                        tempObj.data = idno.trim() + ',return';
                        setVeriObj(tempObj);
                        setCertificateNumber(tempObj.serial);
                    }
                    // setCertificateNumber('web');
                }
            }
        }
    }, [applyReturnModalVisible]);
    const returnAmount = userCollateral.reduce(
        (preVal, curVal) => preVal + curVal.returnQty,
        0
    );

    return (
        <>
            <Modal
                show={applyReturnModalVisible}
                onHide={closeApplyReturnModal}
                title={'確認退還擔保品資料'}
            >
                <form
                    onSubmit={async e => {
                        e.preventDefault();
                        // 簽驗
                        if (!signWeb) {
                            // 測試機關閉簽驗
                            updateData('certificateNumber', certificateNumber);
                        } else {
                            const verifyResult = await verifySignFunc(veriObj);
                            updateData('certificateNumber', certificateNumber);
                            if (verifyResult.data.code !== '0') {
                                setErrMsg(verifyResult.data.message);
                                updateData('certModalVisible', true);
                                closeApplyReturnModal();
                                return;
                            }
                        }
                        // 簽驗結束
                        updateData('applyDisabled', true);
                        const returnSwitch = await getReturnBusinessTime();
                        if (returnSwitch) {
                            closeApplyReturnModal();
                            const detailList = userCollateral.map(
                                ({
                                    stockNo: collateralId,
                                    returnQty: qty,
                                    stockName: collateralName,
                                }) => ({
                                    collateralId,
                                    qty,
                                    collateralName,
                                })
                            );
                            const postData = { detailList, certificateNumber };
                            await applyReturn(postData);
                            updateUserInfo();
                        } else {
                            closeApplyReturnModal();
                        }
                        // }
                    }}
                >
                    <h4 className="title fw-bolder mb-2">
                        請您確認以下申請資料
                    </h4>
                    <h5 className="title mt-3 mb-1">本次退還擔保品明細</h5>
                    <div className="stock-inv d-flex flex-nowrap justify-content-between align-items-center px-3 px-md-2 pt-2 pb-1 mb-4">
                        <div className="stock-scrol col-9 col-sm-10 table-responsive-lg">
                            {userCollateral.map(
                                ({ stockName, stockNo, returnQty }, index) => {
                                    return (
                                        !!returnQty && (
                                            <div
                                                key={`returnCst_ ${index}`}
                                                className="stock-card text-center rounded-2 bg-white fs-12 me-2 mb-1 float-start"
                                            >
                                                <div className="stock-name text-black2 p-2">
                                                    <span>{stockName}</span>
                                                    <small className="gray-light ms-1">
                                                        {stockNo}
                                                    </small>
                                                </div>
                                                <div className="stock-number text-white rounded-bottom ">
                                                    {returnQty}
                                                    <small>張</small>
                                                </div>
                                            </div>
                                        )
                                    );
                                }
                            )}
                        </div>
                        <div className="fs-15 text-center col-3 col-sm-2">
                            合計
                            <b className="num text-orange mx-1">
                                {returnAmount}
                            </b>
                            張
                        </div>
                    </div>
                    <p className="caln-num mb-4 text-black">
                        退還以上擔保品，試算維持率為
                        <span className="p-1 rounded-2 ms-2">
                            {borrowingAmount
                                ? Math.floor(mtRate * 100) / 100
                                : 0}
                            %
                        </span>
                    </p>
                    <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_cancel btn rounded-pill  text-sm-center"
                            type="button"
                            onClick={() => {
                                closeApplyReturnModal();
                            }}
                        >
                            回上一步
                        </button>
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="submit"
                            disabled={applyDisabled}
                        >
                            確認申請
                        </button>
                    </div>
                </form>
            </Modal>
            <CertModal msg={errMsg} />
        </>
    );
};

export default observer(ApplyReturnModal);
